import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicy() {
  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <Link to="/">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="mr-1 h-4 w-4" />
            Retour
          </Button>
        </Link>
        <h1 className="text-2xl font-bold text-slate-900">
          Politique de Confidentialite
        </h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Responsable du traitement</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            <strong>Peerlab</strong> — admin@peerlab.fr
          </p>
          <p>
            Le responsable du traitement des donnees personnelles collectees via
            MakeMyDoc est la societe Peerlab. Pour toute question relative a la
            protection de vos donnees, vous pouvez nous contacter a
            admin@peerlab.fr.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Donnees collectees</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none">
          <ul className="space-y-1">
            <li>
              <strong>Informations de profil</strong> : nom, adresse email, preferences de modele IA.
            </li>
            <li>
              <strong>Sources de recherche</strong> : articles importes (titre, resume, auteurs, metadonnees bibliographiques).
            </li>
            <li>
              <strong>Evaluations et criteres</strong> : grilles de criteres definies, scores generes par l'IA, passages cites.
            </li>
            <li>
              <strong>Historique de chat</strong> : messages echanges avec l'assistant IA sur les documents.
            </li>
            <li>
              <strong>Donnees de transaction</strong> : achats de credits, soldes, historique d'utilisation.
            </li>
            <li>
              <strong>Journaux d'audit</strong> : actions effectuees dans l'application (screening, import, evaluation).
            </li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Sous-traitants et services tiers</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none">
          <ul className="space-y-1">
            <li>
              <strong>OpenAI</strong> (Etats-Unis) : screening et evaluation par IA (GPT-4).
            </li>
            <li>
              <strong>Anthropic</strong> (Etats-Unis) : evaluation par IA (Claude).
            </li>
            <li>
              <strong>Supabase</strong> (Union Europeenne — Paris) : hebergement, base de donnees, authentification.
            </li>
            <li>
              <strong>Stripe</strong> (Etats-Unis) : traitement des paiements.
            </li>
            <li>
              <strong>Semantic Scholar</strong> (Etats-Unis) : enrichissement des metadonnees bibliographiques.
            </li>
            <li>
              <strong>Resend</strong> (Etats-Unis) : envoi d'emails transactionnels.
            </li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Base legale</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Le traitement de vos donnees repose sur :
          </p>
          <ul className="space-y-1">
            <li>
              <strong>Votre consentement</strong> (Article 6(1)(a) du RGPD) : lors de la creation de votre compte et de l'acceptation des conditions d'utilisation.
            </li>
            <li>
              <strong>L'execution du contrat</strong> (Article 6(1)(b) du RGPD) : necessaire a la fourniture du service MakeMyDoc.
            </li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Duree de conservation</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none">
          <ul className="space-y-1">
            <li>
              <strong>Donnees du compte</strong> (profil, sources, evaluations, criteres) : conservees pendant toute la duree de vie du compte.
            </li>
            <li>
              <strong>Historique de chat</strong> : 1 an apres le dernier message.
            </li>
            <li>
              <strong>Journaux d'audit</strong> : 90 jours.
            </li>
            <li>
              <strong>Donnees de transaction</strong> : 5 ans (obligations legales et comptables).
            </li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Vos droits</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Conformement au RGPD, vous disposez des droits suivants :
          </p>
          <ul className="space-y-1">
            <li><strong>Droit d'acces</strong> : obtenir une copie de vos donnees personnelles.</li>
            <li><strong>Droit de rectification</strong> : corriger des donnees inexactes ou incompletes.</li>
            <li><strong>Droit a l'effacement</strong> : demander la suppression de vos donnees.</li>
            <li><strong>Droit a la portabilite</strong> : recevoir vos donnees dans un format structure et lisible.</li>
            <li><strong>Droit a la limitation</strong> : restreindre le traitement de vos donnees.</li>
            <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos donnees.</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous a <strong>admin@peerlab.fr</strong>.
          </p>
        </CardContent>
      </Card>

      <p className="text-xs text-slate-400 text-center pb-6">
        Derniere mise a jour : mars 2026
      </p>
    </div>
  );
}
